import {addPutMethodToJson, put} from '../utils'
import {makeFormData} from "./utils";

export default host => (channelId, id, {name, imageId, hasBackgroundImage, active}) =>
  put(`${host}/channels/${channelId}/sections/${id}`,
    JSON.stringify(addPutMethodToJson(makeFormData({name, imageId, hasBackgroundImage, active}))))
    .then(response => response.json())
